module.exports = __webpack_public_path__ + "img/bprocade.e7aa4eed.svg";